<template>
   <div class="row">
      <div class="col-lg-12">
         <div class="card">
            <div class="card-body">
               <div class="invoice-title">
                  <h4 class="float-right font-size-16">Número de Pedido # PORTAL-{{order.id}}</h4>
                  <div class="mb-3">
                     <img src="@/assets/images/logo-asein-dark.jpg" alt="logo" />
                  </div>
               </div>
               <hr />
               <div class="row">

               </div>
               <div class="row">
                  <div class="col-3">
                     <address>
                        <strong>Cliente:</strong>
                        <br />{{ order.empresa }}
                     </address>
                  </div>
                  <div class="col-5">
                     <address>
                        <strong>Punto de venta:</strong>
                        <br />{{ order.pv }}
                     </address>
                  </div>
                  <div class="col-4 text-right">
                     <address>
                        <strong>Fecha del pedido:</strong>
                        <br />{{ fecha }}
                        <br />
                        <br />
                     </address>
                  </div>
               </div>
               <div class="p-2 mt-3">
                  <h3 class="font-size-16">Resumen del pedido</h3>
               </div>
               <div class="table-responsive">
                  <table class="table">
                     <thead>
                        <tr>
                           <th>Referencia</th>
                           <th>Descripción</th>
                           <th style="width: 70px;">Unidades</th>
                           <th class="text-right">PVP Uni.</th>
                           <th class="text-right">Descuento</th>
                           <th class="text-right">PVP Total</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-for="(item, index) in order.items" :key="index">
                           <td>{{ item.ref }}</td>
                           <td>{{ item.descr }}</td>
                           <td class="text-center">{{ item.uni }}</td>
                           <td class="text-right">{{ item.pvp | currency }}</td>
                           <td class="text-right">{{ item.descuento }}%</td>
                           <td class="text-right">{{ item.pvpTotal | currency }}</td>
                        </tr>

                        <tr class="text-right">
                           <td></td>
                           <td></td>
                           <td></td>
                           <td colspan="2" class="border-0">
                              <strong>Total</strong>
                           </td>
                           <td class="border-0 text-right">
                              <h4 class="m-0">{{ total | currency }}</h4>
                           </td>
                        </tr>

                     </tbody>
                  </table>
               </div>
               <div class="row px-5 mb-5">
                  <div class="col-12 text-center" style="border: 1px solid #808080;">
                     <p><strong>Observaciones: </strong>{{ order.observaciones }}</p>
                  </div>
               </div>
               <div class="d-print-none">
                  <div class="float-right">
                     <a href="javascript:window.print()" class="btn btn-dark">
                        <i class="fa fa-print"></i>
                     </a>
                     <router-link v-if="$route.path == '/pedidos/nuevo'" to="/pedidos/listado"><button type="button" class="btn w-md ml-1 btn-danger">Cerrar</button></router-link>
                     <a v-else @click="cerrar"><button type="button" class="btn w-md ml-1 btn-danger">Cerrar</button></a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   export default {
      name: 'NewOrder',
      props: {
         order: {
            type: Object,
            default: function() {
            return [];
            }
         }
      },
      computed: {
         total() {
            let total = 0
            this.order.items.forEach(element => total = total + parseFloat(element.pvpTotal) )
            return total
         },
         fecha() {
            var fecha = this.order['fecha']
            fecha = fecha.toLocaleString();
            return fecha
         }
      },
      methods: {
         cerrar () {
            this.$parent.mostrarAlbaran = false
         }
      }
   };
</script>